import { createEmptyFetchable } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { ResetCCPhoneVerificationAction, VerifyCCPhoneAction } from 'components/features/creditCard/creditCardStore/actions'
import { PhoneVerifyApiResponse } from 'components/features/creditCard/creditCardStore/endpoints'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { PAGE_CHANGED } from 'actions/globalActions'

const INITIAL_STATE = createEmptyFetchable<PhoneVerifyApiResponse>()
export const verifyPhoneReducer: Reducer<CreditCardAppState['verifyPhoneRequest']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case VerifyCCPhoneAction.type: {
      if (action.meta === 'request') {
        const { errorsMap, ...restPrevState } = prevState
        return {
          ...restPrevState,
          isLoading: true,
          errorCode: null,
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
          errorsMap: action.payload.errorsMap,
        }
      }

      return {
        ...INITIAL_STATE,
        data: action.payload.response,
      }
    }

    case PAGE_CHANGED: {
      if (`${ action.payload.next }`.indexOf('/credit-card/onboarding/phone') === 0) {
        return prevState
      }

      return {
        ...INITIAL_STATE,
      }
    }

    case ResetCCPhoneVerificationAction.type: {
      return {
        ...INITIAL_STATE,
      }
    }
  }
  return prevState

}
